import { Stack } from "@mui/material";
import { PageSection } from "../../components/PageSection";
import foundersPhoto from "../../assets/images/nicolas_luis.webp";
import { NameOrigin } from "./components/NameOrigin";
import { Founders } from "./components/Founders";
import { Essence } from "./components/Essence";
import { Manifesto } from "./components/Manifesto";

export function About() {
  return (
    <PageSection
      overline="Sobre"
      title="Sobre a Groowv"
      subtitle="Ritmo, evolução e identidade em cada apresentação."
    >
      <Stack spacing={{ xs: 12, md: 18 }}>
        <NameOrigin />
        <Founders image={foundersPhoto} />
        <Essence />
        <Manifesto />
      </Stack>
    </PageSection>
  );
}
